import { Directive, HostListener, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Redirect } from '../models/redirect';
import { UserService } from '@app/user';

@Directive({
    selector: '[appRedirect]',
    standalone: false
})
export class RedirectDirective {
    private readonly router = inject(Router);
    private readonly userService = inject(UserService);
    @Input() appRedirect: Redirect;

    @HostListener('keyup.enter')
    @HostListener('click')
    onClick() {
        this.redirect(this.appRedirect);
    }

    redirect(data: Redirect) {
        switch (data.type) {
            case 'course': {
                this.router.navigate(['/library/mission/', data.missionId, 'course', data.id, 'current', true]);
                break;
            }
            case 'mission': {
                this.router.navigate(['/library/mission/', data.id]);
                break;
            }
            case 'path': {
                if (this.userService.access.includes('explore-extended')) {
                    this.router.navigate(['/explore', 'learning-path', data.id], { queryParams: { return: 'all' } });
                    return;
                }

                this.router.navigate(['/my-learning']);

                break;
            }
        }
    }
}
